export interface Messages {
  appName: string;
  install: string;
  privateBetaNotice: string;
  languageName: string;
  menu: {
    play: string;
    nickname: string;
    nicknamePlaceholder: string;
    character: string;
    customize: string;
    difficulty: string;
    easy: string;
    normal: string;
    hard: string;
    lives: string;
    balloons: string;
    settings: string;
    instructions: string;
    highScores: string;
    options: string;
    language: string;
    fullscreen: string;
    exitFullscreen: string;
  };
  character: {
    title: string;
    girl: string;
    boy: string;
    skin: string;
    hair: string;
    outfit: string;
    save: string;
    back: string;
    preview: string;
  };
  instructions: {
    title: string;
    p1: string;
    p2: string;
    p3: string;
    p4: string;
    start: string;
    skipTutorial: string;
    playTutorial: string;
    back: string;
  };
  tutorial: {
    skip: string;
    next: string;
    aim: string;
    throw: string;
    ammo: string;
    reload: string;
    lives: string;
    combo: string;
    gold: string;
    done: string;
  };
  hud: {
    score: string;
    combo: string;
    power: string;
    pause: string;
  };
  pause: {
    title: string;
    resume: string;
    restart: string;
    help: string;
    music: string;
    ambient: string;
    sfx: string;
    accessibility: string;
    fullscreen: string;
    menu: string;
  };
  countdown: string;
  gameover: {
    title: string;
    cheerRecord: string;
    cheerGreat: string;
    cheerGood: string;
    cheerOk: string;
    noLives: string;
    noFrisbees: string;
    score: string;
    bestCombo: string;
    popped: string;
    shots: string;
    hits: string;
    accuracy: string;
    newRecord: string;
    replay: string;
    menu: string;
    board: string;
    boardEasy: string;
    boardNormal: string;
    boardHard: string;
    changeDifficulty: string;
    chooseDifficulty: string;
  };
  scores: {
    title: string;
    empty: string;
    back: string;
    date: string;
  };
  options: {
    title: string;
    shake: string;
    textSize: string;
    reduceMotion: string;
    highContrast: string;
    colorAssist: string;
    aimLength: string;
    clearScores: string;
    resetAll: string;
    confirmClear: string;
    confirmReset: string;
    yes: string;
    no: string;
    back: string;
    cleared: string;
    resetDone: string;
    replayTutorial: string;
    langHint: string;
    fullscreenHint: string;
    installHint: string;
    installInstalled: string;
    installInstalledHint: string;
    installUnavailable: string;
    installUnsupported: string;
    tutorialHint: string;
    instructionsHint: string;
    tabSound: string;
    tabAccess: string;
    tabGeneral: string;
    tabHelp: string;
    tabScores: string;
    tabData: string;
  };
  rotate: {
    title: string;
    message: string;
  };
  help: {
    title: string;
    body: string;
    close: string;
  };
}

export const fr: Messages = {
  appName: "Beach Pop",
  install: "Installer",
  privateBetaNotice:
    "Version bêta privée — utilisation réservée aux essais. Installez uniquement depuis le lien officiel fourni par MaxNova Studio.",
  languageName: "Français",
  menu: {
    play: "Jouer",
    nickname: "Pseudonyme",
    nicknamePlaceholder: "Ton nom de plage",
    character: "Personnage",
    customize: "Personnaliser",
    difficulty: "Difficulté",
    easy: "Facile",
    normal: "Normal",
    hard: "Difficile",
    lives: "vies",
    balloons: "ballons max",
    settings: "Paramètres",
    instructions: "Instructions",
    highScores: "Meilleurs pointages",
    options: "Options",
    language: "Langue",
    fullscreen: "Plein écran",
    exitFullscreen: "Quitter le plein écran",
  },
  character: {
    title: "Personnaliser",
    girl: "Fille",
    boy: "Garçon",
    skin: "Teint",
    hair: "Cheveux",
    outfit: "Tenue",
    save: "Enregistrer",
    back: "Retour",
    preview: "Aperçu",
  },
  instructions: {
    title: "Comment jouer",
    p1: "Restez appuyé pour viser, relâchez pour lancer un frisbee en ligne droite. La puissance est fixe.",
    p2: "Vous avez trois frisbees. Un tir raté en retire un et remet le combo à zéro. Un tir réussi restaure les trois.",
    p3: "Les ballons montent puis redescendent. S'ils touchent le sable, vous perdez une vie. Le ballon doré active les frisbees traversants pendant 10 secondes.",
    p4: "Facile : 10 vies et 1 ballon. Normal : 5 vies et 2 ballons. Difficile : 3 vies et 3 ballons. La partie n'a pas de fin : la vitesse augmente jusqu'à 10 000 points.",
    start: "Continuer",
    skipTutorial: "Passer le tutoriel",
    playTutorial: "Lancer le tutoriel",
    back: "Retour",
  },
  tutorial: {
    skip: "Passer",
    next: "Compris",
    aim: "Maintenez pour viser le ballon. Une ligne pointillée montre la direction.",
    throw: "Relâchez pour lancer. La trajectoire est droite.",
    ammo: "Vous avez trois frisbees. Un tir dans le vide en retire un.",
    reload: "Touchez un ballon pour recharger instantanément les trois frisbees.",
    lives: "Si un ballon touche le sable, un cœur disparaît.",
    combo: "Chaque réussite augmente le combo et multiplie les points.",
    gold: "Le ballon doré active un pouvoir traversant pendant 10 secondes.",
    done: "Vous voilà prêt. Amusez-vous sur la plage !",
  },
  hud: {
    score: "Pointage",
    combo: "Combo",
    power: "Pouvoir doré",
    pause: "Pause",
  },
  pause: {
    title: "Pause",
    resume: "Reprendre",
    restart: "Recommencer",
    help: "Aide",
    music: "Musique",
    ambient: "Ambiance",
    sfx: "Effets",
    accessibility: "Accessibilité",
    fullscreen: "Plein écran",
    menu: "Menu principal",
  },
  countdown: "Reprise",
  gameover: {
    title: "Fin de partie",
    cheerRecord: "Nouveau record de plage !",
    cheerGreat: "Vague de points spectaculaire !",
    cheerGood: "Belle série sous le soleil !",
    cheerOk: "La prochaine vague sera la bonne !",
    noLives: "Plus de vies",
    noFrisbees: "Plus de frisbees",
    score: "Pointage final",
    bestCombo: "Meilleur combo",
    popped: "Ballons éclatés",
    shots: "Tirs effectués",
    hits: "Tirs réussis",
    accuracy: "Précision",
    newRecord: "Nouveau record !",
    replay: "Rejouer",
    menu: "Menu principal",
    board: "Meilleurs pointages",
    boardEasy: "Meilleurs pointages — niveau Facile",
    boardNormal: "Meilleurs pointages — niveau Normal",
    boardHard: "Meilleurs pointages — niveau Difficile",
    changeDifficulty: "Changer la difficulté",
    chooseDifficulty: "Choisir une difficulté",
  },
  scores: {
    title: "Meilleurs pointages",
    empty: "Aucun pointage pour ce mode.",
    back: "Retour",
    date: "Date",
  },
  options: {
    title: "Paramètres",
    shake: "Tremblement d'écran",
    textSize: "Taille du texte",
    reduceMotion: "Réduire les animations",
    highContrast: "Contraste renforcé",
    colorAssist: "Distinction des couleurs",
    aimLength: "Longueur de la visée",
    clearScores: "Effacer les classements",
    resetAll: "Réinitialiser toutes les données",
    confirmClear: "Effacer les cinq meilleurs pointages de chaque mode ?",
    confirmReset: "Réinitialiser langue, personnage, options et classements ?",
    yes: "Oui, supprimer",
    no: "Annuler",
    back: "Retour",
    cleared: "Classements effacés.",
    resetDone: "Toutes les données ont été réinitialisées.",
    replayTutorial: "Rejouer le tutoriel",
    langHint: "Choisir la langue de l'interface.",
    fullscreenHint: "Afficher le jeu en plein écran.",
    installHint: "Ajouter Beach Pop à l'appareil.",
    installInstalled: "Déjà installée",
    installInstalledHint: "Beach Pop est ouvert comme application sur cet appareil.",
    installUnavailable: "Installation indisponible",
    installUnsupported:
      "Ce navigateur ne propose pas l'installation. Sur iPhone, utilisez Partager, puis Sur l'écran d'accueil.",
    tutorialHint: "Revoir les étapes guidées.",
    instructionsHint: "Lire comment jouer.",
    tabSound: "Son",
    tabAccess: "Accessibilité",
    tabGeneral: "Général",
    tabHelp: "Aide",
    tabScores: "Meilleurs pointages",
    tabData: "Données",
  },
  rotate: {
    title: "Tournez l'appareil",
    message: "Beach Pop se joue uniquement en paysage.",
  },
  help: {
    title: "Aide",
    body: "Visez en maintenant, lancez en relâchant. Un miss retire un frisbee. Un impact recharge les trois. Un ballon au sol retire une vie. Le doré traverse pendant 10 secondes. Pause automatique si l'onglet est caché.",
    close: "Fermer",
  },
};
